import { FC } from 'react'

import { useQueryApi } from 'peach/data/useQueryApi'

import { R } from 'core/helpers'
import { isNotFoundError } from 'core/helpers/error'
import { useServicesGet } from 'core/types'

import ModelLink from './ModelLink'

type ServiceLinkProps = {
  serviceId: string
}

const ServiceLink: FC<ServiceLinkProps> = ({ serviceId }) => {
  const [_, { companyId }] = useQueryApi()
  const { data: service, isLoading } = useServicesGet({
    companyId,
    serviceId,
    options: {
      throwOnError: R.isNot(isNotFoundError),
    },
  })

  const link = companyId
    ? `/companies/${companyId}/monitoring/services/${serviceId}`
    : undefined

  return (
    <ModelLink
      id={serviceId}
      isLoading={isLoading}
      link={link}
      model={service}
    />
  )
}

export default ServiceLink
